import { createBrowserRouter, Navigate } from 'react-router-dom';

// Layouts
import { RootLayout } from './layouts/RootLayout';
import { ProtectedLayout } from './layouts/ProtectedLayout';

// Public pages
import SignInPage from './pages/signin';
import SignUpPage from './pages/signup';

// Protected pages
import TradingPage from './pages/trading';
import SwapPage from './pages/swap';
import WalletPage from './pages/wallet';
import HistoryPage from './pages/history';
import OraclesPage from './pages/oracles/page';
import PreferencesPage from './pages/preferences';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/trading" replace />,
      },
      {
        path: 'signin',
        element: <SignInPage />,
      },
      {
        path: 'signup',
        element: <SignUpPage />,
      },
      {
        path: '/',
        element: <ProtectedLayout />,
        children: [
          {
            path: 'trading',
            element: <TradingPage />,
          },
          {
            path: 'swap',
            element: <SwapPage />,
          },
          {
            path: 'wallet',
            element: <WalletPage />,
          },
          {
            path: 'history',
            element: <HistoryPage />,
          },
          {
            path: 'oracles',
            element: <OraclesPage />,
          },
          {
            path: 'preferences',
            element: <PreferencesPage />,
          },
        ],
      },
      {
        path: '*',
        element: (
          <div className="flex min-h-screen items-center justify-center">
            <div className="text-center">
              <h1 className="text-4xl font-bold">404</h1>
              <p className="text-muted-foreground">Page not found</p>
            </div>
          </div>
        ),
      },
    ],
  },
]);
